export class transaction_bevalida {
  pais: string = null;
  correo: string = null;
  contrasena: string = null;
  AMOUNT: number = null;
  response: string = null;
  responseCode: string = null;
  STATUS: string = null;
}

export class BevalidaReturnTransaction {
  franquicia: string = null;
  fecha: string = null;
}
